

























































































































































































































































import { Component, mixins } from 'nuxt-property-decorator'
import BaseModal from '../../components/modals/BaseModal.vue'
import { UserMixin } from '~/node_modules/sitis-nuxt/lib/mixins'

@Component({
  components: {
    BaseModal
  }
})
export default class RegistrationModal extends mixins(UserMixin) {
  phoneNumber = '';
  userName = '';
  $modal: any;

  get submitIsDisabled (): boolean {
    return ![this.phoneNumber, this.userName].every(Boolean)
  }

  onBeforeOpen ({ params }: { params?: { phoneNumber?: string } }): void {
    this.phoneNumber = (params && params?.phoneNumber) || ''
    this.userName = ''
  }

  async submitForm (): Promise<void> {
    await this.registerUser({
      phone: this.phoneNumber,
      name: this.userName
    })
    this.$modal.show('login-modal', {
      phoneNumber: this.phoneNumber
    })
    this.close()
  }

  close (): void {
    this.$modal.hide('registration-modal')
  }
}
